import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppMetadataHandler, CommonUtilty, LookupDataService } from 'app/BaseFramework';
import { ClientHandlingService } from 'app/BaseFramework/core/services/clientHandling/client-handling.service';
import { updateClient } from 'app/BaseFramework/shared/actions/client.action';
import { Subscription, of, zip } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-enlist-client-records',
  templateUrl: './enlist-client-records.component.html',
  styleUrls: ['./enlist-client-records.component.scss']
})
export class EnlistClientRecordsComponent implements OnInit, OnDestroy {


  constructor(private commonUtility: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private clientStore: Store<{ clientStore: any }>,
    private clientHandlingService: ClientHandlingService,
    private lookupDataService: LookupDataService
  ) { }

  uiConfig = {};
  _clientRole: string = null;
  @Input() set config(configVal) {
    if (configVal) {
      this.uiConfig = configVal;
      this._clientRole = this.uiConfig['roleType'];
      this.updateUIConfig();
      this._extractLookups(this.uiConfig).subscribe(res => this.lookupData = res)
    }
  }

  _IO: any;
  @Input() set IO(value: any) {
    if (value) {
      this._IO = value;
    }
  }

  formatterPercent = (value: number): string => `${value || 0} %`;
  parserPercent = (value: string): string => value.replace(' %', '');

  capturedClientDataList = [];
  private clientStoreSubscription: Subscription;

  ngOnInit(): void {
    this.checkSearchAddFeature();
    this.clientStoreSubscription = this.clientStore.select('clientStore').subscribe(data => {
      this.extractRoleSpecificClientDataFromStore(data);
    });
  }

  searchAddText = 'Search / Add';
  checkSearchAddFeature() {
    if (this.uiConfig && this.uiConfig['allowSearchAdd']) {
      switch (this.uiConfig['allowSearchAdd']) {
        case 'SEARCH':
          this.searchAddText = 'Search';
          break;
        case 'ADD':
          this.searchAddText = 'Add';
          break;
        case 'BOTH':
          this.searchAddText = 'Search / Add';
          break;
        default:
          this.searchAddText = 'Search / Add';
          break;
      }
    }
  }

  updateUIConfig() {
    if (this.uiConfig && this.commonUtility.isArrayIterable(this.uiConfig['columnsConfig'])) {
      this.uiConfig['columnsConfig'].forEach(column => {
        if (this.clientHandlingService.transactionClientListDONames.includes(column.entityCd)) {
          column.flattenType = 'transactionClientData';
        } else {
          column.flattenType = 'flattenClientDOData';
        }
      });
    }
  }

  extractRoleSpecificClientDataFromStore(clientData) {
    if (clientData && clientData.payload && this._clientRole) {
      /**Using Spread operator to copy array is throwing an error for editable fields binding (inside the grid), hence done deep copy using json parser***/
      this.capturedClientDataList = this.commonUtility.isArrayIterable(clientData.payload[this._clientRole]) ? JSON.parse(JSON.stringify(clientData.payload[this._clientRole])) : [];
    }
  }

  currentClientDataObj = {};
  showCaptureClientModel: boolean = false;

  openCaptureClientModel(data?) {
    this.currentClientDataObj = data || {};
    this.showCaptureClientModel = true;
  }

  emittedClientData(clientList) {
    if (this.commonUtility.isArrayIterable(clientList)) {
      clientList.forEach(client => {
        let existingClientIndex = this.capturedClientDataList.findIndex(item => item['clientDOData'].guid == client.guid);

        let flattenObj = this.flattenCapturedClientData(client);
        let tempCLientMapObj = {
          "clientDOData": { ...client },
          "flattenData": { ...flattenObj }
        }
        if (existingClientIndex != -1) {
          this.capturedClientDataList[existingClientIndex] = { ...tempCLientMapObj };
        } else {
          this.capturedClientDataList.push({ ...tempCLientMapObj });
        }
      });
    }
    this.showCaptureClientModel = false;
    this.toggleRefreshClientDataGrid();
    this.clientHandlingService.clientRoleDataMap[this._clientRole] = [...this.capturedClientDataList];
    this.clientStore.dispatch(updateClient({ payload: { ...this.clientHandlingService.clientRoleDataMap } }));
    //this.sendClientDataToTransaction();
  }

  flattenCapturedClientData(clientObj) {
    let flattenObj = {
      "flattenClientDOData": {},
      "transactionClientData": {}
    }
    if (this.uiConfig && this.uiConfig['columnsConfig']) {

      let flattenedIO = this.commonUtility.plainflattenObject(clientObj, 'unsafe', '4');

      this.uiConfig['columnsConfig'].forEach(config => {
        if (config['entityCd'] == "ClientDO") {
          config.fieldMapping = config.fieldGenericMapping.replace(/baseDO-/g, '');
        }
        if (this.clientHandlingService.transactionClientListDONames.includes(config['entityCd'])) {
          flattenObj['transactionClientData'][config.fieldKey] = this.currentClientDataObj && this.currentClientDataObj['flattenData'] && this.currentClientDataObj['flattenData']['transactionClientData'] ? this.currentClientDataObj['flattenData']['transactionClientData'][config.fieldKey] : null;
        } else {
          flattenObj['flattenClientDOData'][config.fieldKey] = flattenedIO[config.fieldMapping];
        }
      });

      /**Even though configuration may not have below two fields, we must update this two fields as it is mandatory for transaction client list**/
      flattenObj['transactionClientData']['clientRefGuid'] = flattenedIO['guid'];
      flattenObj['transactionClientData']['roleCd'] = this._clientRole;

    }
    return flattenObj;
  }

  removeClientData(data, index) {
    this.capturedClientDataList.splice(index, 1);
    let roleMapIndx = null;
    if (this._clientRole == 'AGENT') {
      if (data && data['clientDOData'] && data['clientDOData']['agentDO']) {
        roleMapIndx = this.clientHandlingService.clientRoleDataMap[this._clientRole].findIndex(item => item['clientDOData']['agentDO'].agentNum == data['clientDOData']['agentDO'].agentNum);
      }
    } else {
      roleMapIndx = this.clientHandlingService.clientRoleDataMap[this._clientRole].findIndex(item => item['clientDOData'].guid == data['clientDOData'].guid);
    }

    if (roleMapIndx != -1) {
      const clientRoleData = this.clientHandlingService.clientRoleDataMap[this._clientRole];
      /**Instead of splice we used filter ans splice is not working due to array reference issue**/
      //clientRoleData.splice(roleMapIndx, 1);
      this.clientHandlingService.clientRoleDataMap[this._clientRole] = clientRoleData.filter((_, index) => index !== roleMapIndx);
    }
    this.toggleRefreshClientDataGrid();
    this.clientStore.dispatch(updateClient({ payload: { ...this.clientHandlingService.clientRoleDataMap } }));

  }

  refreshClientDataGrid: boolean = true;
  toggleRefreshClientDataGrid() {
    this.refreshClientDataGrid = false;
    setTimeout(() => {
      this.refreshClientDataGrid = true;
    }, 100);
  }

  updateClientTransactionData(newValue, index, key, flattenType) {
    // const updatedItem = { ...this.capturedClientDataList[index]['flattenData'][flattenType], key: newValue };
    // this.capturedClientDataList[index]['flattenData'][flattenType] = updatedItem;
    this.clientHandlingService.clientRoleDataMap[this._clientRole] = [...this.capturedClientDataList];
    //this.clientStore.dispatch(updateClient({payload :{...this.clientHandlingService.clientRoleDataMap}}));
  }

  ngOnDestroy() {
    if (this.clientStoreSubscription) {
      this.clientStoreSubscription.unsubscribe();
    }
  }

  /***********Dynamically bind lookup***************/
  lookup$ = {};

  private _lookupData = {};
  set lookupData(lookupResponse: any) {
    if (this.commonUtility.isArrayIterable(lookupResponse)) {
      lookupResponse.forEach(lookupRes => {
        if (this.commonUtility.isArrayIterable(lookupRes))
          this._lookupData[lookupRes[0].lookupCd] = this.commonUtility.deepCopy(lookupRes)
      });
    }
  }

  get lookupData() {
    return this._lookupData
  }

  private _extractLookups(metaData) {

    if (metaData && this.commonUtility.isArrayIterable(metaData.columnsConfig)) {
      let lookupSubjectsList = []
      metaData.columnsConfig.forEach(column => {
        if (column.fieldType == 'COMBO' && column.lookupCd) {
          this.lookup$[column.lookupCd] = this.lookupDataService.getLookup(column.lookupCd)
          lookupSubjectsList.push(this.lookupDataService.getLookup(column.lookupCd))
        }
      });

      const a$ = zip(lookupSubjectsList);

      const result$ = a$.pipe(
        map(results => results)
      )

      return result$
    }
    else {
      return of(null)
    }
  }
  /***********END: Dynamically bind lookup***************/

  /*sendClientDataToTransaction(){
    if(this._IO && this._IO['clientDOs']){
      if(!Array.isArray(this._IO['clientDOs']) || this._IO['clientDOs'].length <= 0){
        this._IO['clientDOs'] = [];
      }
      if(this.commonUtility.isArrayIterable(this.capturedClientDataList)){
        this.capturedClientDataList.forEach(client => {
          let isExistingClientIndx = this._IO['clientDOs'].findIndex(item => item.guid == client['clientDOData'].guid);
          if(isExistingClientIndx != -1){
            this._IO['clientDOs'][isExistingClientIndx] = {...client['clientDOData']};
          }else{
            this._IO['clientDOs'].push([...client['clientDOData']]);
          }
        });
      }

      let DO = this.commonUtility.getDOName(this._IO); // TODO: May be need to extract node from SmartUI Config
      let clientNode = this.clientHandlingService.extractClientNode(DO);

    }
  }*/

  uiConfig_test = {
    "roleType": "NOMINEE",
    "allowSearchAdd": "BOTH",
    "columnsConfig": [
      {
        "controlId": "field-ClientNum-7764",
        "fieldName": "Client Number",
        "fieldKey": "clientNum",
        "fieldType": "INPUT",
        "lookupCd": null,
        "vocabularyCd": "clientNum",
        "entityCd": "ClientDO",
        "disabled": null,
        "hidden": null,
        "defaultValue": null,
        "extractElementFromArray": false,
        "fieldGenericMapping": "baseDO-clientNum",
        "fieldMapping": "clientDOs-clientNum",
        "validationList": [],
        "maxlength": 50,
        "productRenderingList": []
      },
      {
        "controlId": "field-FirstName-2779",
        "fieldName": "First Name",
        "fieldKey": "firstName",
        "fieldType": "INPUT",
        "lookupCd": null,
        "vocabularyCd": "FirstName",
        "entityCd": "PersonDO",
        "disabled": null,
        "hidden": null,
        "defaultValue": null,
        "extractElementFromArray": false,
        "fieldGenericMapping": "baseDO-personDO-firstName",
        "fieldMapping": "personDO-firstName",
        "validationList": [],
        "maxlength": 50,
        "productRenderingList": []
      },
      {
        "controlId": "field-GenderCd-8654",
        "fieldName": "Gender Code",
        "fieldKey": "genderCd",
        "fieldType": "COMBO",
        "lookupCd": "genderCd",
        "vocabularyCd": "GenderCd",
        "entityCd": "PersonDO",
        "disabled": null,
        "hidden": null,
        "defaultValue": null,
        "extractElementFromArray": false,
        "fieldGenericMapping": "baseDO-personDO-genderCd",
        "fieldMapping": "personDO-genderCd",
        "validationList": [],
        "maxlength": 50,
        "productRenderingList": []
      },
      {
        "controlId": "field-DateOfBirth-7070",
        "fieldName": "Date Of Birth",
        "fieldKey": "dateOfBirth",
        "fieldType": "DATE",
        "lookupCd": null,
        "vocabularyCd": "DateOfBirth",
        "entityCd": "PersonDO",
        "disabled": null,
        "hidden": null,
        "defaultValue": null,
        "extractElementFromArray": false,
        "fieldGenericMapping": "baseDO-personDO-dateOfBirth",
        "fieldMapping": "personDO-dateOfBirth",
        "validationList": [],
        "maxlength": 50,
        "productRenderingList": []
      },
      {
        "fieldName": "Nominee Split Percent Policy Client",
        "fieldKey": "nomineeSplitPrct",
        "fieldType": "NUMBER",
        "lookupCd": null,
        "vocabularyCd": "NomineeSplitPrctPolicyClient",
        "entityCd": "PolicyClientDO",
        "controlId": "editable-grid-NomineeSplitPrctPolicyClient-7813",
        "columnVisibility": true,
        "visible": true,
        "disabled": false,
        "isEditable": true,
        "sortOrder": 0,
        "isCustomTemplate": false,
        "extractElementFromArray": null,
        "fieldGenericMapping": "baseDO-proposalClients-nomineeSplitPrct",
        "fieldMapping": "proposalDO-proposalClients-nomineeSplitPrct",
        "defaultValue": null,
        "validationList": [],
        "productRenderingList": []
      },
      {
        "fieldName": "Relation Code Policy Client",
        "fieldKey": "relationCd",
        "fieldType": "COMBO",
        "lookupCd": "relationCd",
        "vocabularyCd": "RelationCdPolicyClient",
        "entityCd": "PolicyClientDO",
        "controlId": "editable-grid-RelationCdPolicyClient-2550",
        "columnVisibility": true,
        "visible": true,
        "disabled": false,
        "isEditable": true,
        "sortOrder": 0,
        "isCustomTemplate": false,
        "extractElementFromArray": null,
        "fieldGenericMapping": "baseDO-proposalClients-relationCd",
        "fieldMapping": "proposalDO-proposalClients-relationCd",
        "defaultValue": null,
        "validationList": [],
        "productRenderingList": []
      },
      {
        "fieldName": "Role Code Policy Client",
        "fieldKey": "roleCd",
        "fieldType": "INPUT",
        "lookupCd": "insuredRoleCd",
        "vocabularyCd": "RoleCdPolicyClient",
        "entityCd": "PolicyClientDO",
        "controlId": "editable-grid-RoleCdPolicyClient-3699",
        "columnVisibility": true,
        "visible": false,
        "disabled": false,
        "sortOrder": 0,
        "isCustomTemplate": false,
        "extractElementFromArray": null,
        "fieldGenericMapping": "baseDO-proposalClients-roleCd",
        "fieldMapping": "proposalDO-proposalClients-roleCd",
        "defaultValue": null,
        "validationList": [],
        "productRenderingList": []
      },
      {
        "fieldName": "Client Ref Guid Policy Client",
        "fieldKey": "clientRefGuid",
        "fieldType": "INPUT",
        "lookupCd": null,
        "vocabularyCd": "ClientRefGuidPolicyClient",
        "entityCd": "PolicyClientDO",
        "controlId": "editable-grid-ClientRefGuidPolicyClient-2343",
        "columnVisibility": true,
        "visible": false,
        "disabled": false,
        "sortOrder": 0,
        "isCustomTemplate": false,
        "extractElementFromArray": null,
        "fieldGenericMapping": "baseDO-proposalClients-clientRefGuid",
        "fieldMapping": "proposalDO-proposalClients-clientRefGuid",
        "defaultValue": null,
        "validationList": [],
        "productRenderingList": []
      }
    ],
    "columnsConfig_lightGrid": {
      "type": "editable-grid",
      "controlId": "editable-grid-2304",
      "heading": "New Editable Grid",
      "icon": "table",
      "gridClass": "grid-1x",
      "visible": true,
      "disabled": false,
      "sortOrder": 0,
      "isCustomTemplate": false,
      "entityFetchURL": "",
      "entityFetchBy": "",
      "enableAddRemoveRows": true,
      "columns": [
        {
          "fieldName": "Title Code",
          "fieldKey": "titleCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "TitleCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "controlId": "editable-grid-TitleCd-6908",
          "columnVisibility": true,
          "visible": true,
          "sortOrder": 0,
          "extractElementFromArray": null,
          "fieldGenericMapping": "baseDO-personDO-titleCd",
          "fieldMapping": "personDO-titleCd",
          "maxlength": 50,
          "validationList": [],
          "productRenderingList": []
        },
        {
          "controlId": "editable-grid-FirstName-2779",
          "fieldName": "First Name",
          "fieldKey": "firstName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "FirstName",
          "entityCd": "PersonDO",
          "disabled": null,
          "columnVisibility": true,
          "visible": true,
          "sortOrder": 0,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-firstName",
          "fieldMapping": "personDO-firstName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "editable-grid-MiddleName-4743",
          "fieldName": "Middle Name",
          "fieldKey": "middleName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "MiddleName",
          "entityCd": "PersonDO",
          "disabled": null,
          "columnVisibility": true,
          "visible": true,
          "sortOrder": 0,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-middleName",
          "fieldMapping": "personDO-middleName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "editable-grid-LastName-5072",
          "fieldName": "Last Name",
          "fieldKey": "lastName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "LastName",
          "entityCd": "PersonDO",
          "disabled": null,
          "columnVisibility": true,
          "visible": true,
          "sortOrder": 0,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-lastName",
          "fieldMapping": "personDO-lastName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "editable-grid-GenderCd-8654",
          "fieldName": "Gender Code",
          "fieldKey": "genderCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "GenderCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "columnVisibility": true,
          "visible": true,
          "sortOrder": 0,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-genderCd",
          "fieldMapping": "personDO-genderCd",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "editable-grid-DateOfBirth-7070",
          "fieldName": "Date Of Birth",
          "fieldKey": "dateOfBirth",
          "fieldType": "DATE",
          "lookupCd": null,
          "vocabularyCd": "DateOfBirth",
          "entityCd": "PersonDO",
          "disabled": null,
          "columnVisibility": true,
          "visible": true,
          "sortOrder": 0,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-dateOfBirth",
          "fieldMapping": "personDO-dateOfBirth",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        }
      ],
      "entity": null,
      "childEntity": null,
      "rowSelectable": "NOSELECTION",
      "readOnly": false,
      "allowPagination": false,
      "paginationPosition": "top",
      "showRecordPerPageOption": false,
      "fieldMapping": "proposalDO-proposalClients",
      "vocabularyCd": null,
      "entityCd": null

    },
    "clientTypeLookupCd": "clientTypeCd",
    "captureContactDetails": true,
    "captureAddressDetails": true,
    "captureIdentityDetails": true,
    "personFormConfig": {
      "controlId": "form-6100",
      "heading": "New Section",
      "icon": "profile",
      "formItems": [
        {
          "controlId": "field-TitleCd-7764",
          "fieldName": "Title Code",
          "fieldKey": "titleCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "TitleCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-titleCd",
          "fieldMapping": "personDO-titleCd",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-FirstName-2779",
          "fieldName": "First Name",
          "fieldKey": "firstName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "FirstName",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-firstName",
          "fieldMapping": "personDO-firstName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-MiddleName-4743",
          "fieldName": "Middle Name",
          "fieldKey": "middleName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "MiddleName",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-middleName",
          "fieldMapping": "personDO-middleName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-LastName-5072",
          "fieldName": "Last Name",
          "fieldKey": "lastName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "LastName",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-lastName",
          "fieldMapping": "personDO-lastName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-GenderCd-8654",
          "fieldName": "Gender Code",
          "fieldKey": "genderCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "GenderCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-genderCd",
          "fieldMapping": "personDO-genderCd",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-DateOfBirth-7070",
          "fieldName": "Date Of Birth",
          "fieldKey": "dateOfBirth",
          "fieldType": "DATE",
          "lookupCd": null,
          "vocabularyCd": "DateOfBirth",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-dateOfBirth",
          "fieldMapping": "personDO-dateOfBirth",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-CitizenshipCd-7921",
          "fieldName": "Citizenship Code",
          "fieldKey": "citizenshipCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "CitizenshipCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-citizenshipCd",
          "fieldMapping": "personDO-citizenshipCd",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-MaritalStatusCd-433",
          "fieldName": "Marital Status Code",
          "fieldKey": "maritalStatusCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "MaritalStatusCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-maritalStatusCd",
          "fieldMapping": "personDO-maritalStatusCd",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-SourceOfIncomeCd-5650",
          "fieldName": "Source Of Income Code",
          "fieldKey": "sourceOfIncomeCd",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "SourceOfIncomeCd",
          "entityCd": "PersonDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-personDO-sourceOfIncomeCd",
          "fieldMapping": "personDO-sourceOfIncomeCd",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        }
      ]
    },
    "organizationFormConfig": {
      "controlId": "form-6101",
      "heading": "New Section",
      "icon": "profile",
      "formItems": [
        {
          "controlId": "field-CompanyName-3066",
          "fieldName": "Company Name",
          "fieldKey": "companyName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "CompanyName",
          "entityCd": "OrganisationDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-organisationDO-companyName",
          "fieldMapping": "organisationDO-companyName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        },
        {
          "controlId": "field-ContactPersonName-6485",
          "fieldName": "Contact Person Name",
          "fieldKey": "contactPersonName",
          "fieldType": "INPUT",
          "lookupCd": null,
          "vocabularyCd": "ContactPersonName",
          "entityCd": "OrganisationDO",
          "disabled": null,
          "hidden": null,
          "defaultValue": null,
          "extractElementFromArray": false,
          "fieldGenericMapping": "baseDO-organisationDO-contactPersonName",
          "fieldMapping": "organisationDO-contactPersonName",
          "validationList": [],
          "maxlength": 50,
          "productRenderingList": []
        }
      ]
    },
    "searchConfig": {
      "searchCriteria": "searchProposal",
      "searchURL": "client/searchInsured",
      "itemsPerPage": 100,
      "isSingleSelection": false,
      "searchTableHeaders": [
        {
          "header": "Client ID",
          "key": "clientNum",
          "searchFilter": true,
          "sortFilter": true,
          "isVisible": true
        },
        {
          "header": "First Name",
          "key": "firstName",
          "searchFilter": true,
          "sortFilter": true,
          "isVisible": true
        },
        {
          "header": "Last Name",
          "key": "lastName",
          "searchFilter": true,
          "sortFilter": true,
          "isVisible": true
        },
        {
          "header": "DOB",
          "key": "dateOfBirth",
          "pipe": "date",
          "searchFilter": true,
          "sortFilter": true,
          "isVisible": true
        },
        {
          "header": "Contact No.",
          "key": "contactNum",
          "searchFilter": true,
          "sortFilter": false,
          "isVisible": true
        }
      ]
    }
  }
}
